import { Card, CardProps } from 'antd'

export interface KBCardProps extends CardProps {}

export function KBCard(props: KBCardProps) {
  return <Card bordered={false} {...props}></Card>
}
